module.exports = __webpack_public_path__ + "static/media/icons-hb-notification.a2a6895f.svg";